import { render, staticRenderFns } from "./HealthActionCatalogHeader.vue?vue&type=template&id=83c5e5b0"
import script from "./HealthActionCatalogHeader.vue?vue&type=script&lang=js"
export * from "./HealthActionCatalogHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports